<script>
import date from '@/mixins/date'
import ImageResource from '../resources/image'
import CompanyRegisterForm from '@/components/CompanyRegisterForm.vue'
import ImageUpload from '@/components/ImageUpload.vue'

export default {
    name: 'RecruitCompanyEdit',
    components: {
        CompanyRegisterForm,
        ImageUpload,
    },
    mixins: [date],
    props: {
        companyResource: {
            type: Object,
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        async onSubmit() {
            this.loading = true

            await this.companyResource.save()
            
            this.$bvToast.toast('Company saved successfully', {
                title: 'Company Profile',
                autoHideDelay: 5000,
                variant: 'success',
            })

            this.loading = false
        },
        async onCropperSave(dataURL) {
            let imageResource = ImageResource.fromDataURL(dataURL)
            await imageResource.save()
            this.companyResource.set('image', imageResource.id)
            await this.companyResource.resolveRelated({ managers: ['image'] })
            await this.companyResource.save()
        }
    },
}
</script>

<template>
    <div v-page-title="'Edit Company'">
        <b-row>
            <b-col md="8" class="section-heading mb-5">
                <h4>Company Profile</h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="9">
                <company-register-form :company-resource="companyResource" @success="onSubmit">
                    <template slot="submit" slot-scope="data">
                        <b-button :disabled="loading" variant="primary" size="lg" @click="data.handler">Submit</b-button>
                    </template>
                </company-register-form>
            </b-col>

            <b-col>
                <div class="company-image">
                    <b-avatar rounded variant="light" size="100%" :src="companyResource.get('image.source')">
                    </b-avatar>
                    <image-upload @success="onCropperSave" class="image-upload">
                        <!-- <template #button="data">
                            <b-icon icon="image" @click="data.handler" />
                        </template> -->
                    </image-upload>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<style lang="scss" scoped>
.company-image {
    width: 120px;
}
</style>
